import React from 'react';

export const PREFIJOS = {
  prospecto: 'PRO',
  cotizacion: 'COT',
  proyecto: 'PRY',
  mantenimiento: 'MNT',
  servicio: 'SRV',
  factura: 'FAC',
  tarea: 'TAR',
  cliente: 'CLI',
  equipo: 'EQP',
  contrato: 'CTR',
};

export const COLORES_FOLIO = {
  PRO: { bg: '#ede9fe', color: '#7c3aed' },
  COT: { bg: '#fef9c3', color: '#854d0e' },
  PRY: { bg: '#dbeafe', color: '#1d4ed8' },
  MNT: { bg: '#dcfce7', color: '#166534' },
  SRV: { bg: '#ffedd5', color: '#9a3412' },
  FAC: { bg: '#d1fae5', color: '#065f46' },
  TAR: { bg: '#fce7f3', color: '#9d174d' },
  CLI: { bg: '#e0f2fe', color: '#0369a1' },
  EQP: { bg: '#f0fdf4', color: '#15803d' },
  CTR: { bg: '#f5f3ff', color: '#6d28d9' },
};

export function generarFolio(prefijo, registrosExistentes = []) {
  const año = new Date().getFullYear();
  const foliosDelAño = registrosExistentes
    .filter(r => r.folio && r.folio.startsWith(prefijo + '-' + año))
    .map(r => parseInt(r.folio.split('-')[2]) || 0);
  const ultimo = foliosDelAño.length > 0 ? Math.max(...foliosDelAño) : 0;
  const siguiente = String(ultimo + 1).padStart(3, '0');
  return prefijo + '-' + año + '-' + siguiente;
}

export function BadgeFolio({ folio, archivado, style }) {
  if (!folio) return null;
  const prefijo = folio.split('-')[0];
  const base = COLORES_FOLIO[prefijo] || { bg: '#f3f4f4', color: '#4e5357' };
  const bg = archivado ? '#e8e8e8' : base.bg;
  const color = archivado ? '#999' : base.color;
  return (
    <span style={{
      display: 'inline-block',
      padding: '2px 10px',
      borderRadius: '20px',
      fontSize: '11px',
      fontWeight: '700',
      letterSpacing: '0.05em',
      background: bg,
      color: color,
      fontFamily: 'Poppins, sans-serif',
      whiteSpace: 'nowrap',
      ...style,
    }}>
      {folio}
    </span>
  );
}

export function anioFolio(folio) {
  if (!folio) return null;
  const parts = folio.split('-');
  return parts.length >= 2 ? parseInt(parts[1], 10) : null;
}
